import React from 'react';
import {connect} from 'react-redux';
import {
    guidedTours,
} from '../../../../../actions/guidedToursActions';
import Popup from '../../index';
import Button from '../../../button/index';
import {getSharingDetailsPopup} from '../../../../../actions/sharingDetailsActions';
import {FormattedMessage} from 'react-intl';
import Icon from '../../../icon/index';
import {showHowDoesItWorksPopup} from "../../../../../actions/popupActions";
import './index.css';

class GuidedToursListPopup extends React.Component {

    constructor(props) {
        super(props);

        this.reInitGuidedTours = this.reInitGuidedTours.bind(this);
    }

    reInitGuidedTours() {

        this.props.setGuidedTours({
            "t1" : false,
            "t2" : false,
            "t3" : false,
            "t4" : false,
        });

        this.props.setShowHowDoesItWorksPopup(false);
    }

    render() {
        if(this.props.showHowDoesItWorksPopup){
            return (
                <Popup className="p-3" onClose={() => this.props.setShowHowDoesItWorksPopup(false)}>
                    <h2><Icon className="text-info" name="question-circle-o"/> <FormattedMessage id="popup.guided_tours_list.how_does_it_work" defaultMessage="how does it work" /></h2>
                    <ul className="guided-tours-list pl-0 my-4">
                        <li>
                            <FormattedMessage id="popup.guided_tours_list.step1_select_your_label" defaultMessage="Step1 : Select a label you want to share." />
                        </li>
                        <li>
                            <FormattedMessage id="popup.guided_tours_list.step2_add_a_new_collaborator" defaultMessage="Step2 : Add a new collaborator." />
                        </li>
                        <li>
                            <FormattedMessage id="popup.guided_tours_list.step3_permissions_on_the_shared_group_of_contacts" defaultMessage="Step3 : Set permissions for the collaborators on the shared label." />
                        </li>
                        <li>
                            <FormattedMessage id="popup.guided_tours_list.step4_devices_outlook_and_my_contacts_sync" defaultMessage="Step4 : Sync to ‘My Contacts’ for Outlook and Mobile devices synchronization." />
                        </li>
                        <li>
                            <FormattedMessage id="popup.guided_tours_list.step5_save_changes" defaultMessage="Step5 : Save your changes." />
                        </li>
                    </ul>
                    <Button
                        className="btn-primary float-right"
                        onClick={this.reInitGuidedTours}
                    >
                        <FormattedMessage id="guided_tour.btn.replay_tutorial" defaultMessage="Replay tutorial" />
                    </Button>
                </Popup>
            )
        } else {
            return null;
        }

    }
}

const mapStateToProps = (state) => {
    return {
        showHowDoesItWorksPopup : state.popupReducer.showHowDoesItWorksPopup,
        profile: state.profileReducer.getProfile
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setShowHowDoesItWorksPopup : (boolean) => {
            dispatch(showHowDoesItWorksPopup(boolean))
        },
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setGuidedTours : (object) => {
            dispatch(guidedTours(object))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GuidedToursListPopup);
